import { clone } from "../../utils/CoreUtils";
import { hasEverHadFlag, hasFlag } from "../Flags";
import { PlayerContextState } from "../PlayerContext";
import {
  getTotalExpRequiredForLevel,
  getUnlockedSchools,
} from "../spells/ElementsAndSchools";
import { Item } from "./Item";

const items: Record<string, Item> = {};

export function registerItem(item: Item) {
  items[item.getId()] = item;
}

export function getItemById(id: string): Item {
  return items?.[id] as Item;
}

export function getItemByIdNullable(id: string): Item | undefined {
  return items?.[id];
}

export function getCraftableItems(state: PlayerContextState): Item[] {
  if (!isCraftingUnlocked(state)) {
    return [];
  }

  return Object.values(items).filter((item) => item.isCraftable(state));
}

export function isInventoryUnlocked(state: PlayerContextState): boolean {
  return (
    hasFlag(state, "new_inventory_unlocked") ||
    hasFlag(state, "inventory_unlocked")
  );
}

export function isCraftingUnlocked(state: PlayerContextState): boolean {
  return (
    hasFlag(state, "crafting_unlocked") || hasFlag(state, "inventory_unlocked")
  );
}

export function hasEverUnlockedCrafting(state: PlayerContextState): boolean {
  return (
    hasEverHadFlag(state, "crafting_unlocked") ||
    hasEverHadFlag(state, "inventory_unlocked")
  );
}

export function getAllItemsEverCraftable(state: PlayerContextState): Item[] {
  const modifiedContext = clone(state);
  modifiedContext.isFake = true;
  getUnlockedSchools(modifiedContext).forEach((school) => {
    modifiedContext.schoolExperience[school] = getTotalExpRequiredForLevel(
      modifiedContext,
      state.global.maxSchoolLevels?.[school] ?? 1,
      school,
    );
  });
  return getCraftableItems(modifiedContext);
}
